<!-- Clear Filters -->
<div>
  <div [ngClass]="this.stack ? '' : ''">
    <div class="d-flex justify-content-between">
      <div class="d-flex align-items-center">
        <fa-icon size="sm" class="filter-toggle custom-text-color" [class.collapsed]="!filtersExpanded"  [icon]="filtersExpanded ? faChevronDown : faChevronUp" (click)="toggleFilters()"></fa-icon>&nbsp;
         
          <div class="filters-text">
              <h6 class="mb-0 pb-1" style="font-weight: bold;">Filters</h6>
              <small class="custom-text-color fs-6 ls-1 fw-medium" [style.visibility]="gridCountDataAndMessage?.message? 'visible': 'hidden'" >{{gridCountDataAndMessage?.message}}</small>
          </div>
      </div>
     
      <div class="d-flex align-items-center pb-4 gap-3">
        <mat-slide-toggle color="primary" [checked]="checked" (change)="onCheckboxChange($event)">&nbsp; <span class="spacing-normal-font custom-text-color">Retain filters</span></mat-slide-toggle>
        <button
          mat-button  
          class="spacing-normal-font custom-text-color"
          style="color:#0F172B"
          (click)="onResetButtonClick()">
         <fa-icon size="sm"  [icon]="faFilter"></fa-icon>&nbsp;
          Clear all
        </button>
      </div>
    

    </div>
  </div> 
  <div class="filters-body" [class.collapsed]="!filtersExpanded">
    <hr class="mb-0 mt-3" style="opacity: 0.1;">
  
  <div class="row">

  <!-- Crop Type -->
  <div class="col-12 filter" [ngClass]="this.stack ? '' : 'col-lg-2'"
    *ngIf="this.filterSettings?.cropSettings?.display">
    <label class="dropdown-label"><i class="fas fa-seedling me-2"></i>{{"Crop" | tenantWords}}</label>
    <angular2-multiselect id="crop" name="crop" [data]="this.filterService.listOfCrops || []"
      (onSelect)="this.filterService.filterCropYearByCropID()"
      (onDeSelect)="this.filterService.filterCropYearByCropID()" [(ngModel)]="this.filterService.selectedCrop"
      [settings]="cropDropdownSettings">
    </angular2-multiselect>
  </div>

  <!-- Crop Year -->
  <div class="col-12 filter" [ngClass]="this.stack ? '' : 'col-lg-2'"
    *ngIf="this.filterSettings?.cropYearSettings?.display">
    <label class="dropdown-label"><i class="far fa-calendar-check me-2"></i> Crop Year</label>
    <angular2-multiselect id="years" name="years" [data]="this.filterService.listOfYears || []"
      (onSelect)="this.eventFilterChange('')" (onDeSelectAll)="this.eventFilterChange('')"
      (onDeSelect)="this.eventFilterChange('')" (onSelectAll)="this.eventFilterChange('')"
      (onGroupSelect)="this.eventFilterChange('')" (onGroupDeSelect)="this.eventFilterChange('')"
      [(ngModel)]="filterService.selectedCropYear" [settings]="cropYearDropdownSettings">
    </angular2-multiselect>
  </div>

  <!-- Customer -->
  <div class="col-12 filter" [ngClass]="this.stack ? '' : 'col-lg-2'"
    *ngIf="this.filterSettings?.customerSettings?.display">
    <label class="dropdown-label">{{"Customer" | tenantWords}}</label>
    <angular2-multiselect id="customer" name="customer" [data]="this.filterService.listOfCustomers || []"
      [(ngModel)]="this.filterService.selectedCustomer"
      (onSelect)="this.eventFilterChange('Customer')"
      (onDeSelect)="this.eventFilterChange('Customer')"
      (onDeSelectAll)="this.eventFilterChange('Customer')"
      (focus)="onDropdownFocus('customer')"
      (blur)="onDropdownBlur('customer')"
      [settings]="customerDropdownSettings">
    </angular2-multiselect>
  </div>
  <!-- Farm -->
  <div class="col-12 filter" [ngClass]="this.stack ? '' : 'col-lg-2'"
    *ngIf="this.filterSettings?.farmSettings?.display">
    <label class="dropdown-label"><i class="fas fa-tractor me-2"></i>{{"Farm" | tenantWords}}</label>
    <angular2-multiselect id="farms" name="farms" [data]="this.filterService.listOfFarms || []"
      [(ngModel)]="this.filterService.selectedFarms" (onSelect)="this.eventFilterChange('')"
      (onDeSelect)="this.eventFilterChange('')" (onDeSelectAll)="this.eventFilterChange('')"
      (onSelectAll)="this.eventFilterChange('')" (onGroupSelect)="this.eventFilterChange('')"
      (onGroupDeSelect)="this.eventFilterChange('')" [settings]="farmDropdownSettings">
    </angular2-multiselect>
  </div>
  <!-- Work Order Type -->
  <div class="col-12 filter" [ngClass]="this.stack ? '' : 'col-lg-2'"
    *ngIf="this.filterSettings?.workOrderSettings?.display">
    <label class="dropdown-label"><i class="fas fa-briefcase me-2"></i>{{"Work Order Type" | tenantWords}}</label>
    <angular2-multiselect id="workOrderType" name="workOrderType" [data]="this.filterService.listOfWorkOrderTypes || []"
      [(ngModel)]="this.filterService.selectedWorkOrderTypes" (onSelect)="this.eventFilterChange('')"
      (onDeSelect)="this.eventFilterChange('')" (onDeSelectAll)="this.eventFilterChange('')"
      (onSelectAll)="this.eventFilterChange('')" (onGroupSelect)="this.eventFilterChange('')"
      (onGroupDeSelect)="this.eventFilterChange('')" [settings]="workOrderTypeDropdownSettings">
    </angular2-multiselect>
  </div>
  <!-- Variety -->
  <div class="col-12 filter" [ngClass]="this.stack ? '' : 'col-lg-2'"
    *ngIf="this.filterSettings?.varietySettings?.display">
    <label class="dropdown-label"><i class="fas fa-list me-2"></i>{{"Variety" | tenantWords}}</label>
    <angular2-multiselect id="varieties" name="varieties" [data]="this.filterService.listOfVarieties || []"
      [(ngModel)]="filterService.selectedVarieties" (onSelect)="this.eventFilterChange('')"
      (onDeSelect)="this.eventFilterChange('')" (onDeSelectAll)="this.eventFilterChange('')"
      (onSelectAll)="this.eventFilterChange('')" (onGroupSelect)="this.eventFilterChange('')"
      (onGroupDeSelect)="this.eventFilterChange('')" [settings]="varietyDropdownSettings">
    </angular2-multiselect>
  </div>

  <!-- barcode -->
  <div class="col-12 filter" [ngClass]="this.stack ? '' : 'col-lg-2'"
    *ngIf="this.filterSettings?.barcodeSettings?.display">
    <!-- <label class="dropdown-label">{{ this.filterSettings?.barcodeSettings?.label ? this.filterSettings.barcodeSettings.label : ("Barcode" | tenantWords) }}</label> -->
    <mat-form-field style="width: 100%;">
      <input matInput type="text" [placeholder]="this.filterSettings?.barcodeSettings?.label ? this.filterSettings.barcodeSettings.label : 'Barcode'" [(ngModel)]="filterService.barcode" (ngModelChange)="filterService.change()" />
    </mat-form-field>
  </div>

  <!-- Scouting -->
  <div class="col-12 filter" [ngClass]="this.stack ? '' : 'col-lg-2'"
    *ngIf="this.filterSettings?.fieldEventSettings?.display">
    <label class="dropdown-label"><i class="fas fa-binoculars me-2"></i>{{"Scouting" | tenantWords}} Type</label>
    <angular2-multiselect id="scoutingType" name="scoutingType" [data]="this.filterService.listOfFieldEventTypes || []"
      [(ngModel)]="filterService.selectedFieldEventType" (onSelect)="this.eventFilterChange('')"
      (onDeSelect)="this.eventFilterChange('')" (onDeSelectAll)="this.eventFilterChange('')"
      (onSelectAll)="this.eventFilterChange('')" (onGroupSelect)="this.eventFilterChange('')"
      (onGroupDeSelect)="this.eventFilterChange('')" [settings]="fieldEventDropdownSettings">
    </angular2-multiselect>
  </div>
  
  <!-- Block -->
  <div class="col-12 filter" [ngClass]="this.stack ? '' : 'col-lg-2'"
    *ngIf="this.filterSettings?.blockSettings?.display">

    <label class="dropdown-label"><i class="fas fa-cube me-2"></i>{{"Block" | tenantWords}}</label>
    <angular2-multiselect id="blocks" name="blocks" [data]="this.filterService.listOfBlocks || []"
      [(ngModel)]="filterService.selectedBlocks" (onSelect)="this.eventFilterChange('Block')"
      (onGroupSelect)="this.eventFilterChange('Block')" (onGroupDeSelect)="this.eventFilterChange('Block')"
      (onDeSelect)="this.eventFilterChange('Block')"
      (onDeSelectAll)="this.eventFilterChange('Block')" (onSelectAll)="this.eventFilterChange('Block')"
      (onGroupSelect)="this.eventFilterChange('Block')" (onGroupDeSelect)="this.eventFilterChange('Block')"
      [settings]="blockDropdownSettings">
      <c-search>
        <ng-template>
          <input type="text" (keyup)="onSearchTextChanged('Block')" placeholder="Search"
            style="border: none;width: 100%; height: 100%;outline: none;" [(ngModel)]="this.blockFilterText"  />
        </ng-template>
      </c-search>
    </angular2-multiselect>
  </div>

  <!-- Block Custom Fields -->
  <div *ngFor="let field of this.filterService.customBlockFields" class="col-12 filter"
    [ngClass]="[this.stack ? '' : 'col-lg-2', this.filterSettings?.blockCustomFieldsSettings?.display ? '' : 'noBlockCF']">
    <!-- <div *ngIf="this.filterSettings?.blockCustomFieldsSettings?.display"> -->
    <label class="dropdown-label"><i class="fas fa-th-large me-2"></i>{{field.name}}</label>
    <angular2-multiselect
  [id]='[field.id] + "BlockCustomField"'
  [name]='[field.id] + "BlockCustomField"'
  [data]="field.data || []"
  (onSelect)="eventFilterChange('')"
  (onDeSelect)="eventFilterChange('')"
  (onSelectAll)="eventFilterChange('')"
  (onDeSelectAll)="eventFilterChange('')"
  [(ngModel)]="filterService.selectedBlockCustomFieldValue[
      filterService.customBlockFields.indexOf(field)
    ].data"
  [settings]="GetBlockCustomFieldSettings(field)">
</angular2-multiselect>
    <!-- </div> -->
  </div>

  <!-- Feature Type -->

  <div class="col-12 filter" [ngClass]="this.stack ? '' : 'col-lg-2'"
    *ngIf="this.filterSettings?.featureTypeSettings?.display">
    <label class="dropdown-label"><i class="fas fa-sitemap me-2"></i>{{"Asset" | tenantWords}} Type</label>
    <angular2-multiselect id="featureType" name="featureType" [data]="filterService.listOfFeatureTypes || []"
      (onSelect)="this.eventFilterChange('')" (onDeSelectAll)="this.eventFilterChange('')"
      (onDeSelect)="this.eventFilterChange('')" (onSelectAll)="this.eventFilterChange('')"
      (onGroupSelect)="this.eventFilterChange('')" (onGroupDeSelect)="this.eventFilterChange('')"
      [(ngModel)]="filterService.selectedFeatureTypes" [settings]="featureTypesDropdownSettings">
    </angular2-multiselect>
  </div>

  <div class="col-12 filter" [ngClass]="this.stack ? '' : 'col-lg-2'"
    *ngIf="this.filterSettings?.featureSettings?.display">
    <label class="dropdown-label">{{"Asset" | tenantWords}}</label>
    <angular2-multiselect id="features" name="features" [data]="filterService.listOfFeatures || []"
      (onSelect)="this.eventFilterChange('')" (onDeSelectAll)="this.eventFilterChange('')"
      (onDeSelect)="this.eventFilterChange('')" (onSelectAll)="this.eventFilterChange('')"
      (onGroupSelect)="this.eventFilterChange('')" (onGroupDeSelect)="this.eventFilterChange('')"
      [(ngModel)]="filterService.selectedFeatures" [settings]="featureDropdownSettings">
    </angular2-multiselect>
  </div>


  <div class="col-12 filter" [ngClass]="this.stack ? '' : 'col-lg-2'"
    *ngIf="this.filterSettings?.featureEventTypeSettings?.display">
    <label class="dropdown-label">{{"Asset" | tenantWords}} Event Type</label>
    <angular2-multiselect id="featureEventType" name="featureEventTypes"
      [data]="filterService.listOfFeatureEventTypes || []" (onSelect)="this.eventFilterChange('')"
      (onDeSelectAll)="this.eventFilterChange('')" (onDeSelect)="this.eventFilterChange('')"
      (onSelectAll)="this.eventFilterChange('')" (onGroupSelect)="this.eventFilterChange('')"
      (onGroupDeSelect)="this.eventFilterChange('')" [(ngModel)]="filterService.selectedFeatureEventType"
      [settings]="featureTypesDropdownSettings">
    </angular2-multiselect>
  </div>

  <!-- Inventory Item -->
  <div class="col-12 filter" [ngClass]="this.stack ? '' : 'col-lg-2'"
    *ngIf="this.filterSettings?.inventoryItemSettings?.display">
    <label class="dropdown-label"><i class="fas fa-box-open me-2"></i>{{"Product" | tenantWords}}</label>
    <!-- <label class="custom-font-size custom-text-color">{{"Product" | tenantWords}}</label> -->
    <angular2-multiselect id="inventoryItem" name="inventoryItem" [data]="this.filterService.listOfInventoryItems || []"
      [(ngModel)]="filterService.selectedInventoryItem" (onSelect)="this.eventFilterChange('')"
      (onDeSelect)="this.eventFilterChange('')" (onDeSelectAll)="this.eventFilterChange('')"
      (onSelectAll)="this.eventFilterChange('')" (onGroupSelect)="this.eventFilterChange('')"
      (onGroupDeSelect)="this.eventFilterChange('')" [settings]="inventoryItemDropdownSettings">
    </angular2-multiselect>
  </div>

  <!-- Warehouse -->
  <div class="col-12 filter" [ngClass]="this.stack ? '' : 'col-lg-2'"
    *ngIf="this.filterSettings?.warehouseSettings?.display">
    <label class="dropdown-label"><i class="fas fa-warehouse me-2"></i>{{"Warehouse" | tenantWords}}</label>
    <angular2-multiselect id="warehouse" name="warehouse" [data]="this.filterService.listOfWarehouses || []"
      [(ngModel)]="filterService.selectedWarehouses" (onSelect)="this.eventFilterChange('')"
      (onDeSelect)="this.eventFilterChange('')" (onDeSelectAll)="this.eventFilterChange('')"
      (onSelectAll)="this.eventFilterChange('')" (onGroupSelect)="this.eventFilterChange('')"
      (onGroupDeSelect)="this.eventFilterChange('')" [settings]="warehouseDropdownSettings">
    </angular2-multiselect>
  </div>

  <!-- rooms -->
  <div class="col-12 filter" [ngClass]="this.stack ? '' : 'col-lg-2'"
    *ngIf="this.filterSettings?.roomSettings?.display">
    <label class="dropdown-label"><i class="fas fa-door-open me-2"></i>{{"Room" | tenantWords}}</label>
    <angular2-multiselect id="room" name="room" [data]="this.filterService.listOfRooms || []"
      [(ngModel)]="filterService.selectedRooms" (onSelect)="this.eventFilterChange('Room')"
      (onDeSelect)="this.eventFilterChange('Room')" (onDeSelectAll)="this.eventFilterChange('Room')"
      (onSelectAll)="this.eventFilterChange('Room')" (onGroupSelect)="this.eventFilterChange('Room')"
      (onGroupDeSelect)="this.eventFilterChange('Room')" [settings]="roomDropdownSettings">
      <c-search>
        <ng-template>
          <input type="text" (keyup)="onSearchTextChanged('Room')" placeholder="Search"
            style="border: none;width: 100%; height: 100%;outline: none;" [(ngModel)]="this.roomFilterText" />
        </ng-template>
      </c-search>
    </angular2-multiselect>
  </div>

  <!-- location -->
  <div class="col-12 filter" [ngClass]="this.stack ? '' : 'col-lg-2'"
    *ngIf="this.filterSettings?.locationSettings?.display">
    <label class="dropdown-label"><i class="fas fa-map-marker-alt me-2"></i>{{"Room Location" | tenantWords}}</label>
    <angular2-multiselect id="location" name="location" [data]="this.filterService.listOfLocations || []"
      [(ngModel)]="filterService.selectedLocation" (onSelect)="this.eventFilterChange('Location')"
      (onDeSelect)="this.eventFilterChange('Location')" (onDeSelectAll)="this.eventFilterChange('Location')"
      (onSelectAll)="this.eventFilterChange('Location')" (onGroupSelect)="this.eventFilterChange('Location')"
      (onGroupDeSelect)="this.eventFilterChange('Location')" [settings]="locationDropdownSettings">
      <c-search>
        <ng-template>
          <input type="text" (keyup)="onSearchTextChanged('Location')" placeholder="Search"
            style="border: none;width: 100%; height: 100%;outline: none;" [(ngModel)]="this.locationFilterText" />
        </ng-template>
      </c-search>
    </angular2-multiselect>
  </div>

  <!-- Storage Type -->
  <div class="col-12 filter" [ngClass]="this.stack ? '' : 'col-lg-2'"
    *ngIf="this.filterSettings?.storageSettings?.display">
    <label class="dropdown-label"><i class="fas fa-warehouse me-2"></i>{{"Storage Type" | tenantWords}}</label>
    <angular2-multiselect id="storageType" name="storage" [data]="this.filterService.listOfStorageTypes || []"
      (onSelect)="this.eventFilterChange('')" (onDeSelectAll)="this.eventFilterChange('')"
      (onSelectAll)="this.eventFilterChange('')" (onGroupSelect)="this.eventFilterChange('')"
      (onGroupDeSelect)="this.eventFilterChange('')" (onDeSelect)="this.eventFilterChange('')"
      [(ngModel)]="this.filterService.selectedStorageTypes" [settings]="storageTypesDropdownSettings">
    </angular2-multiselect>
  </div>

  <!-- lotNumber -->
  <div class="col-12 filter" [ngClass]="this.stack ? '' : 'col-lg-2'"
    *ngIf="this.filterSettings?.lotNumberSettings?.display">
    <label class="dropdown-label"><i class="fas fa-hashtag me-2"></i>{{"Lot Number" | tenantWords}}</label>
    <angular2-multiselect id="lotNumber" name="lotNumber" [data]="this.filterService.listOfLotNumbers || []"
      [(ngModel)]="filterService.selectedLotNumber" (onSelect)="this.eventFilterChange('')"
      (onDeSelect)="this.eventFilterChange('')" (onDeSelectAll)="this.eventFilterChange('')"
      (onSelectAll)="this.eventFilterChange('')" (onGroupSelect)="this.eventFilterChange('')"
      (onGroupDeSelect)="this.eventFilterChange('')" [settings]="lotNumberDropdownSettings">
    </angular2-multiselect>
  </div>

  <!-- Shipment Statuses -->
  <div class="col-12 filter" [ngClass]="this.stack ? '' : 'col-lg-2'"
    *ngIf="this.filterSettings?.shipmentStatusSettings?.display">
    <label class="dropdown-label"><i class="fas fa-truck-loading me-2"></i>{{"Shipment" | tenantWords}} Status</label>
    <angular2-multiselect id="shipmentStatus" name="shipmentStatus"
      [data]="this.filterService.listOfShipmentStatuses || []" [(ngModel)]="filterService.selectedShipmentStatuses"
      (onSelect)="this.eventFilterChange('')" (onDeSelect)="this.eventFilterChange('')"
      (onDeSelectAll)="this.eventFilterChange('')" (onSelectAll)="this.eventFilterChange('')"
      (onGroupSelect)="this.eventFilterChange('')" (onGroupDeSelect)="this.eventFilterChange('')"
      (onGroupSelect)="this.eventFilterChange('')" (onGroupDeSelect)="this.eventFilterChange('')"
      [settings]="shipmentStatusDropdownSettings">
    </angular2-multiselect>
  </div>

  <!-- Fieldman -->
  <div class="col-12 filter" [ngClass]="this.stack ? '' : 'col-lg-2'"
    *ngIf="this.filterSettings?.fieldmanSettings?.display">
    <label class="dropdown-label"><i class="fas fa-user-tie me-2"></i>{{"Fieldman" | tenantWords}}</label>
    <angular2-multiselect id="fieldmen" name="fieldmen" [data]="this.filterService.listOfFieldmen || []"
      [(ngModel)]="filterService.selectedFieldmen" (onSelect)="this.eventFilterChange('Fieldman')"
      (onDeSelect)="this.eventFilterChange('Fieldman')" (onDeSelectAll)="this.eventFilterChange('Fieldman')"
      (onSelectAll)="this.eventFilterChange('Fieldman')" (onGroupSelect)="this.eventFilterChange('Fieldman')"
      (onGroupDeSelect)="this.eventFilterChange('Fieldman')" [settings]="fieldmenDropdownSettings">
      <c-search>
        <ng-template>
          <input type="text" (keyup)="onSearchTextChanged('Fieldman')" placeholder="Search"
            style="border: none;width: 100%; height: 100%;outline: none;" [(ngModel)]="this.fieldmanFilterText" />
        </ng-template>
      </c-search>
    </angular2-multiselect>
  </div>

  <!-- UserName -->
  <div class="col-12 filter" [ngClass]="this.stack ? '' : 'col-lg-2'"
    *ngIf="this.filterSettings?.userNameSettings?.display">
    <label class="dropdown-label"><i class="fas fa-user me-2"></i>{{"User" | tenantWords}}</label>
    <angular2-multiselect id="user" name="user" [data]="this.filterService.listOfUserNames || []"
      [(ngModel)]="filterService.selectedUserName" (onSelect)="this.eventFilterChange('')"
      (onDeSelect)="this.eventFilterChange('')" (onDeSelectAll)="this.eventFilterChange('')"
      (onSelectAll)="this.eventFilterChange('')" (onGroupSelect)="this.eventFilterChange('')"
      (onGroupDeSelect)="this.eventFilterChange('')" [settings]="userNameDropdownSettings">
    </angular2-multiselect>
  </div>

  <!-- Brewery -->
  <div class="col-12 filter" [ngClass]="this.stack ? '' : 'col-lg-2'"
    *ngIf="this.filterSettings?.brewerySettings?.display">
    <label class="dropdown-label"><i class="fas fa-beer me-2"></i>{{"Brewery" | tenantWords}}</label>
    <angular2-multiselect id="brewery" name="brewery" [data]="this.filterService.listOfBreweries || []"
      [(ngModel)]="filterService.selectedBrewery" (onSelect)="this.eventFilterChange('')"
      (onDeSelect)="this.eventFilterChange('')" (onDeSelectAll)="this.eventFilterChange('')"
      (onSelectAll)="this.eventFilterChange('')" (onGroupSelect)="this.eventFilterChange('')"
      (onGroupDeSelect)="this.eventFilterChange('')" [settings]="breweryDropdownSettings">
    </angular2-multiselect>
  </div>

  <!-- Carrier -->
  <div class="col-12 filter" [ngClass]="this.stack ? '' : 'col-lg-2'"
    *ngIf="this.filterSettings?.carrierSettings?.display">
    <label class="dropdown-label"><i class="fas fa-truck me-2"></i>{{"Carrier" | tenantWords}}</label>
    <angular2-multiselect id="carrier" name="carrier" [data]="this.filterService.listOfCarriers || []"
      [(ngModel)]="filterService.selectedCarrier" (onSelect)="this.eventFilterChange('')"
      (onDeSelect)="this.eventFilterChange('')" (onDeSelectAll)="this.eventFilterChange('')"
      (onSelectAll)="this.eventFilterChange('')" (onGroupSelect)="this.eventFilterChange('')"
      (onGroupDeSelect)="this.eventFilterChange('')" [settings]="carrierDropdownSettings">
    </angular2-multiselect>
  </div>

  <!-- TruckType -->
  <div class="col-12 filter" [ngClass]="this.stack ? '' : 'col-lg-2'"
    *ngIf="this.filterSettings?.truckTypeSettings?.display">
    <label class="dropdown-label"><i class="fas fa-truck-pickup me-2"></i>{{"Truck Type" | tenantWords}}</label>
    <angular2-multiselect id="truckType" name="truckType" [data]="this.filterService.listOfTruckTypes || []"
      [(ngModel)]="filterService.selectedTruckType" (onSelect)="this.eventFilterChange('')"
      (onDeSelect)="this.eventFilterChange('')" (onDeSelectAll)="this.eventFilterChange('')"
      (onSelectAll)="this.eventFilterChange('')" (onGroupSelect)="this.eventFilterChange('')"
      (onGroupDeSelect)="this.eventFilterChange('')" [settings]="truckTypeDropdownSettings">
    </angular2-multiselect>
  </div>

  <!-- QC Area -->
  <div class="col-12 filter" [ngClass]="this.stack ? '' : 'col-lg-2'"
    *ngIf="this.filterSettings?.qcAreaSettings?.display">
    <label class="dropdown-label"><i class="fas fa-clipboard-check me-2"></i>{{"QC Area" | tenantWords}}</label>
    <angular2-multiselect id="qcArea" name="qcArea" [data]="this.filterService.listOfQcAreas || []"
      [(ngModel)]="filterService.selectedQcAreas" (onSelect)="this.eventFilterChange('')"
      (onDeSelect)="this.eventFilterChange('')" (onDeSelectAll)="this.eventFilterChange('')"
      (onSelectAll)="this.eventFilterChange('')" (onGroupSelect)="this.eventFilterChange('')"
      (onGroupDeSelect)="this.eventFilterChange('')" [settings]="qcAreasDropdownSettings">
    </angular2-multiselect>
  </div>

  <!-- Estimate Types -->
  <div class="col-12 filter" [ngClass]="this.stack ? '' : 'col-lg-2'"
    *ngIf="this.filterSettings?.estimateTypeSettings?.display">
    <label class="dropdown-label"><i class="fas fa-calculator me-2"></i>{{"Estimate Type" | tenantWords}}</label>
    <angular2-multiselect id="estimateTypes" name="estimateTypes" [data]="this.filterService.listOfEstimateTypes || []"
      (onSelect)="this.eventFilterChange('EstimateType')" (onDeSelectAll)="this.eventFilterChange('EstimateType')"
      (onDeSelect)="this.eventFilterChange('EstimateType')" (onSelectAll)="this.eventFilterChange('EstimateType')"
      (onGroupSelect)="this.eventFilterChange('EstimateType')" (onGroupDeSelect)="this.eventFilterChange('EstimateType')"
      [(ngModel)]="this.filterService.selectedEstimateTypes" [settings]="estimateTypeDropdownSettings">
      <c-search>
        <ng-template>
          <input type="text" (keyup)="onSearchTextChanged('EstimateType')" placeholder="Search"
            style="border: none;width: 100%; height: 100%;outline: none;" [(ngModel)]="this.estimateTypeFilterText" />
        </ng-template>
      </c-search>
    </angular2-multiselect>
  </div>

  <!-- pool Types -->
  <div class="col-12 filter" [ngClass]="this.stack ? '' : 'col-lg-2'"
    *ngIf="this.filterSettings?.poolTypeSettings?.display">
    <label class="dropdown-label"><i class="fas fa-swimming-pool me-2"></i>{{"Pool" | tenantWords}}</label>
    <angular2-multiselect id="poolTypes" name="pool" [data]="this.filterService.listOfPoolTypes || []"
      (onSelect)="this.eventFilterChange('')" (onDeSelectAll)="this.eventFilterChange('')"
      (onDeSelect)="this.eventFilterChange('')" (onSelectAll)="this.eventFilterChange('')"
      (onGroupSelect)="this.eventFilterChange('')" (onGroupDeSelect)="this.eventFilterChange('')"
      [(ngModel)]="this.filterService.selectedPoolTypes" [settings]="this.poolDropdownSettings">
    </angular2-multiselect>
  </div>


  <!-- Organic/Conventional? -->
  <div class="col-12 filter" [ngClass]="this.stack ? '' : 'col-lg-2'"
    *ngIf="this.filterSettings?.organicConventionalSettings?.display">
    <label class="dropdown-label"><i class="fas fa-leaf me-2"></i>{{"Org./Conv." | tenantWords}}</label>
    <angular2-multiselect id="orgConv" name="organicConventional" [data]="this.filterService.listOfOrganic || []"
      [(ngModel)]="filterService.selectedOrganicConventional" (onSelect)="this.eventFilterChange('')"
      (onDeSelect)="this.eventFilterChange('')" (onDeSelectAll)="this.eventFilterChange('')"
      (onSelectAll)="this.eventFilterChange('')" (onGroupSelect)="this.eventFilterChange('')"
      (onGroupDeSelect)="this.eventFilterChange('')" [settings]="organicConventionalDropdownSettings">
    </angular2-multiselect>
  </div>

  <!-- Group By -->
  <div class="col-12 filter" [ngClass]="this.stack ? '' : 'col-lg-2'"
    *ngIf="this.filterSettings?.groupingSettings?.display">
    <label class="dropdown-label"><i class="fas fa-layer-group me-2"></i>Grouping</label>
    <angular2-multiselect id="grouping" name="groupings" [data]="this.filterService.allGroupings || []"
      [(ngModel)]="filterService.selectedGrouping" (onSelect)="this.eventFilterChange('')"
      (onDeSelect)="this.eventFilterChange('')" (onDeSelectAll)="this.eventFilterChange('')"
      (onSelectAll)="this.eventFilterChange('')" (onGroupSelect)="this.eventFilterChange('')"
      (onGroupDeSelect)="this.eventFilterChange('')" [settings]="groupingDropdownSettings">
    </angular2-multiselect>
  </div>

  <!-- Include Completed? -->
  <div class="col-12 filter" [ngClass]="this.stack ? '' : 'col-lg-2'"
    *ngIf="this.filterSettings?.includeCompletedSettings?.display">
    <label class="dropdown-label">{{this.filterSettings?.includeCompletedSettings?.label ? this.filterSettings?.includeCompletedSettings?.label : "Completed?" | tenantWords}}</label>
    <angular2-multiselect id="completed" name="completed" [data]="this.filterService.listOfCompleted || []"
      [(ngModel)]="filterService.selectedCompleted" (onSelect)="this.eventFilterChange('')"
      (onDeSelect)="this.eventFilterChange('')" [settings]="includeCompletedSettings">
    </angular2-multiselect>
  </div>

  <!-- Load# -->
  <div class="col-12 filter" [ngClass]="this.stack ? '' : 'col-lg-2'"
    *ngIf="this.filterSettings?.loadSettings?.display">
    <!-- <label class="dropdown-label">{{"Load #" | tenantWords}}</label> -->
    <mat-form-field class="select-form" style="width: 100%;">
      <input matInput type="text" [placeholder]="this.filterSettings?.loadSettings?.label ? this.filterSettings.loadSettings.label : 'Load#'" (keyup.enter)="this.eventFilterChange('')"
        [(ngModel)]="filterService.selectedLoad">
      <button  *ngIf="filterService.loadSearchValue" matSuffix mat-icon-button aria-label="Clear"
        (click)="loadSearchValue= ''; this.eventFilterChange('');">
        <i class="fas fa-times"></i>
      </button>
      <button  matSuffix mat-icon-button aria-label="Search" (click)="this.eventFilterChange('')">
        <fa-icon [icon]="faSearch"></fa-icon>
      </button>
    </mat-form-field>
  </div>

  <!-- Date picker -->
  <div class="col-12" [ngClass]="this.stack ? '' : 'col-lg-2'" style="white-space: nowrap;"
    *ngIf="this.filterSettings?.dateRangeSettings?.display">
    <label style="color: #8b8b8b; min-width: 100%; font-weight:
      normal; cursor: pointer;"><i class="fas fa-calendar-alt me-2"></i>
      <input class="dateTimeInput" [(ngModel)]="filterService.selectedDates" [owlDateTimeTrigger]="dt3"
        placeholder="Date Range" [owlDateTime]="dt3" [selectMode]="'range'"
        (ngModelChange)="filterService.selectDates()">
      <span class="trigger" [owlDateTimeTrigger]="dt3">
        <fa-icon style="margin-left: 3px;" [icon]="faCalendarAlt" size="lg"></fa-icon>
      </span>
      <owl-date-time [pickerType]="'calendar'" #dt3></owl-date-time>
    </label>
  </div>

  <!-- Export -->
  <div class="col-12 filter" [ngClass]="this.stack ? '' : 'col-lg-2'" *ngIf="this.filterSettings?.displayExportButton">
    <button mat-raised-button (click)="this.exportPressed.emit()" style="margin-top: 15px;white-space: nowrap;">
      Export to Excel <fa-icon [icon]="faFileDownload" style="margin-left: 5px;" size="lg"></fa-icon>

    </button>
  </div>

  <!-- Page-specific filters: [kwFilterInline] sits beside the built-in ones, [kwFilterFooter] below them -->
  <div class="col-12 col-lg filter-inline">
    <ng-content select="[kwFilterInline]"></ng-content>
  </div>

  </div>
  <ng-content select="[kwFilterFooter]"></ng-content>
<ng-container *ngIf="gridCountDataAndMessage && gridCountDataAndMessage?.pageSize && gridCountDataAndMessage?.count && gridCountDataAndMessage?.totalCount">
  <div class="row mt-4">
      <div class="d-flex justify-content-between">
          <div>
            <h6 class="custom-text-color p-2" style="font-size: small;"> Showing {{gridCountDataAndMessage?.count}} of {{gridCountDataAndMessage?.totalCount}} results</h6>
          </div>
          <div class="d-flex justify-content-between">
            <ng-container *ngIf="gridCountDataAndMessage?.showPdf">
            <button mat-raised-button class="custom-font-size " style="margin-right: 8px;" (click)="fetchPdf();">
              <span class="custom-text-color" style="letter-spacing: normal;">
                <svg xmlns="http://www.w3.org/2000/svg" class="me-2" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-download"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line></svg>
                PDF
              </span>
            </button>
            </ng-container>
            <ng-container *ngIf="gridCountDataAndMessage?.showExcel">
              <button mat-raised-button class="custom-font-size" (click)="fetchExcel();">
              <span class="custom-text-color" style="letter-spacing: normal;">
                <svg xmlns="http://www.w3.org/2000/svg" class="me-2" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-download"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line></svg>
                Excel
              </span>
            </button>
            </ng-container>
            
          </div>
      </div>
  </div>
</ng-container>
  </div>
</div>